export const colors = {
  white: "var(--t-fill-color-neutral-100)",
  neutral_100: "var(--t-fill-color-neutral-100)",
  neutral_090: "var(--t-fill-color-neutral-090)",
  neutral_080: "var(--t-fill-color-neutral-080)",
  neutral_070: "var(--t-fill-color-neutral-070)",
  neutral_060: "var(--t-fill-color-neutral-060)",
  neutral_050: "var(--t-fill-color-neutral-050)",
  neutral_040: "var(--t-fill-color-neutral-040)",
  neutral_030: "var(--t-fill-color-neutral-030)",
  neutral_020: "var(--t-fill-color-neutral-020)",
  neutral_010: "var(--t-fill-color-neutral-010)",
  error: "var(--t-text-color-status-error)",
  success: "var(--success-color)",
  link: "var(--link--color)",
  warning: "var(--warning-color)"
}

// colors taken from People, color blind safe
export const chartColors = {
  blue: "#93ABDE",
  teal: "#44AA99",
  green: "#117733",
  orange: "#D89059",
  pink: "#CC6677",
  magenta: "#9E4B75",
  gray: "#5D5D5D",
  navy: "#2B5A82"
}
